import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";



import {Component, ElementRef}            from '@angular/core';
//import {HTTP_PROVIDERS}			  from '@angular/http';
import { HttpModule } from '@angular/http';

import {ContentNode}			    from './content-node';
import {ContentListComponent}	from './content-list.component';
import {ContentService}		  	from './content.service';

//import {provide}				      from '@angular/core';
import {XHRBackend}				    from '@angular/http';
import {Input} from "@angular/core";

import {Injectable}            from '@angular/core';

import { appConfig } from '../assets/config/app.config';

import {LoadingContainer, LoadingPage} from	'./loading-container';

@Injectable()
export class UrlVars {

	constructor() { }

	getUrlVars() {
		var vars = [], hash;
		var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	}
}

@Injectable()
export class MainCategoryId {
	constructor(private _urlVars: UrlVars) {
		debugger;
		this.catId = this._urlVars.getUrlVars()['mainCatId'] || 1;
	}

	public catId: string = '1';

}

@Injectable()
@Component({
    selector: 'app-ShalhevetTree',
    //template: `
	//`,    
    templateUrl: './treeView.component.template.html',
	providers: [
		ContentService,
		UrlVars,
		MainCategoryId
	]
})
export class TreeViewComponent extends LoadingPage {
    constructor(public elementRef: ElementRef, private _mainCategoryId: MainCategoryId) {
		super(true);
        debugger;
        var native = this.elementRef.nativeElement;
        this._appTitle = native.getAttribute("appTitle");

		var catId = _mainCategoryId.catId;

        this._catId = catId || native.getAttribute("mainCategoryId");
    }

    private _appTitle: string;

    public _catId: string;

}

@Component({
    selector: 'pageCategoryTitle',
    template: `
		{{this.categoryText}}
	`,
	providers: [
		UrlVars,
		MainCategoryId
	]
})
export class PageCategoryTitleComponent {

    constructor(private _mainCategoryId: MainCategoryId) {
		debugger;
		this.categoryText = this._mainCategoryId.catId == '1' ?
			appConfig.buildingPermitsTitle :
			appConfig.businessLicensingTitle;
		document.title = this.categoryText;
	}

    public categoryText: string;
}


//@NgModule({
//    declarations: [TreeViewComponent, ContentListComponent],
//    imports: [BrowserModule, HttpModule],
//    bootstrap: [TreeViewComponent],
//    providers:[]
//})
//export class ShalhevetTreeModule {

//}





// WEBPACK FOOTER //
// ./src/app/treeView.component.ts